import { SidebarHeader } from "@/components/sidebar/components/SidebarHeader.tsx";
import { useHelp } from "@/pages/help/help.hook.tsx";
import { resolveHelpLanguage } from "@/utils/help-language.ts";
import { SidebarPanelItem, Stack } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const SidebarHelp = () => {
  const { t, i18n } = useTranslation();
  const { slug } = useParams<{
    slug: string;
  }>();
  const language = resolveHelpLanguage(i18n.resolvedLanguage || i18n.language);

  const { helpIndex, getCategoryPath, findCategoryBySlug, findArticleBySlug } = useHelp(language);

  const topLevelCategories = useMemo(() => {
    if (!helpIndex) return [];
    const rootCategory = findCategoryBySlug("");
    if (!rootCategory) return [];
    return rootCategory.children;
  }, [findCategoryBySlug, helpIndex]);

  const selectedCategory = useMemo(() => {
    if (!helpIndex || !slug) return [];
    const isCategory = findCategoryBySlug(slug);
    if (isCategory) {
      return getCategoryPath(isCategory).map((category) => category.id);
    } else {
      const article = findArticleBySlug(slug);
      if (article) {
        const articleCategory = findCategoryBySlug(article.category);
        if (!articleCategory) return [];
        return getCategoryPath(articleCategory).map((category) => category.id);
      }
    }
    return [];
  }, [findArticleBySlug, findCategoryBySlug, getCategoryPath, helpIndex, slug]);

  return (
    <>
      <SidebarHeader title={t("common:help_center")} />
      <Stack className={"px-4"}>
        <Stack gap={"xs"}>
          <SidebarPanelItem
            to={`/help`}
            isActive={selectedCategory.length == 0}
            title={t("common:overview")}
          />
          {topLevelCategories.map((category) => (
            <SidebarPanelItem
              key={`'secondary-menu-${category.title}`}
              to={`/help/collection/${category.id}`}
              isActive={selectedCategory.includes(category.id)}
              title={category.title}
            />
          ))}
        </Stack>
      </Stack>
    </>
  );
};
